<template>
<div style="padding: 1rem 1rem;background: #FAFAFD;position: relative;transform: translate(0);">
  <div style="font-weight: 400;color: rgba(0,0,0,0.8);margin-bottom: 20px;" class="d-flex flex-y-center flex-between">
      <div class="d-flex flex-y-center pointer" style="padding: 0.3rem 0.3rem 0 0;" @click="goHome()">
        <img src="@/assets/icon-home.png" width="40" height="40" alt="">
        <span style="margin-left: 10px;color: rgba(0,0,0,0.8);font-weight: 600;font-size: 20px;">站内公告</span>
      </div>
      <div v-if="false" class="" style="display: flex;gap: 10px;">
        <div class="d-flex flex-y-center pointer"

          style="background: #366EF4; border-radius: 20px;font-size: 14px;color: rgba(255,255,255,0.9);padding: 5px 10px;">
          编辑为已读
        </div>
        <div class="d-flex flex-y-center pointer"

          style="background: #DBE5FD; border-radius: 20px;font-size: 14px;color: #0052D9;padding: 5px 10px;">
          <img src="@/assets/notify-delete.png" width="16" height="16" alt="">
          <span style="">删除</span>
        </div>
      </div>
  </div>

  <!-- 数据表格 -->
  <el-table
    :row-style="{height:'40px', cursor: 'pointer'}"
    :cell-style="{padding:'14px 0px'}"
    :header-cell-style="{background:'#FAFAFD',color:'rgba(0,0,0,0.4)','font-weight': 400, 'font-size': '14px'}"
    :data="tableData"
    :highlight-current-row="false"
    ref="tableContainer"
    class="table-container"
    @row-click="handleRowClick"
    >

    <!-- 复选框列 -->
<!--    <el-table-column
      prop="id"
      type="selection"
      width="55"
      :reserve-selection="true"
    ></el-table-column>
     row-key="id"
     @selection-change="handleSelectionChange"
-->

    <el-table-column align="left"
      prop="title"
      label="标题"
      show-overflow-tooltip
      min-width="100px">
      <template slot-scope="scope">
        <span v-html="scope.row.title"></span>
        <!-- <span v-if="!scope.row.readFlag" style="color: #D54941;background: #FFF0ED;border-radius: 3px 3px 3px 3px;border: 1px solid #D54941;padding: 3px;font-size: 12px;margin-left: 10px;">未读</span> -->
      </template>
    </el-table-column>

    <el-table-column align="left"
      prop="startTime"
      label="时间"
      min-width="100px"/>

    <el-table-column align="left"
      prop="content"
      label="详情"
      show-overflow-tooltip
      min-width="100px">
      <template slot-scope="scope">
        <div class="single-line-content" v-html="scope.row.content"></div>
      </template>
    </el-table-column>

  </el-table>

  <el-row class="pagination-fixed"  v-if="token != ''">
    <el-col>
      <div class="pagination">
        <el-pagination background
          hide-on-single-page
          :page-sizes="paginations.pages"
          :page-size="paginations.size"
          :layout="paginations.layout"
          :total="paginations.total"
          :current-page.sync="paginations.current"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        />
      </div>
    </el-col>
  </el-row>

</div>
</template>
<script>
import * as EnumApi from '@/api/enums'
import * as ArticleApi from '@/api/article'
import { mapState, mapMutations} from 'vuex'
export default {
  name: 'NotifyList',
  components: {

  },
  data() {
    return {
      tableWidth: 0,
      sliderBoxActive: 0,
      showUpdateFlag: false,
      fromType: 'writer_client',
      enums: {},
      intervalId: null,
      uploadFile: {},
    	targetPermit: 'article',
      queryForm: {
        fromType: 'writer-web-notify-all',
        articleGroup: 'MESSAGE',
        current: '',
        size: 20
      },
      rules: {
        name: [
          { required: true, message: '请输入内容', trigger: 'blur' }
        ]
      },
      tableData: [],
      tableData: [],
      progressMap: new Map(),
      activeMenuItem: 1,
      paginations: {
        current: 1, // 当前页
        total: 0, // 总行数
        size: 20, // 每页行数
        // sizes: [20], // 每页行数 调整
        layout: 'total, prev, pager, next' // 翻页属性
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.tableWidth = this.$refs.tableContainer.$el.offsetWidth;
      console.log('tableWidth', this.tableWidth);
    })
    this.handlePage()
  },
  computed: {
  	...mapState(['user', 'currentNotifyId', 'token'])
  },
  beforeDestroy() {
  },
  methods: {
    ...mapMutations(['setCurrentNotifyId',  'setActiveMenuItem']),
    handleRowClick(row, column, event) {
      this.setCurrentNotifyId(row.id)
      this.$router.push(`/newsdetail/${row.id}`)
    },
    handleRemove(item) {
      this.$confirm('确定删除吗?','提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'custom-confirm',
        center: false
      }).then(() => {
        FileApi.remove(item.id).then(res => {
          this.handlePage();
        });
      }).catch((e) => {console.log('error', e)});
    },
    goHome(){
      this.setActiveMenuItem('1')
      if(this.token == ''){
        this.$router.push('/')
      }else{
        this.$router.push('/home')
      }
    },
    handleSelectionChange(val) {
      console.log('select change',val);
      this.multipleSelection = val;
    },
    /**
     * 将数组中指定id的元素移动到首位
     * @param {Array} arr - 原始数组
     * @param {string|number} id - 要移动到首位的元素的id
     * @returns {Array} - 处理后的新数组
     */
    moveItemToFirst(arr, id) {
      // 1. 使用 findIndex 找到目标元素的索引
      const index = arr.findIndex(item => item.id === id);

      // 2. 如果找不到该元素，直接返回原数组
      if (index === -1) return [...arr];

      // 3. 创建新数组（避免修改原数组）
      const newArr = [...arr];

      // 4. 使用 splice 移除目标元素，并插入到首位
      const [targetItem] = newArr.splice(index, 1);
      newArr.unshift(targetItem);

      return newArr;
    },
    handlePage(current) {
      let that = this;
      if (current) {
        that.paginations.current = current
      }
      that.queryForm.current = that.paginations.current
      that.queryForm.size = that.paginations.size

      // 获取表格数据
      ArticleApi.page(that.queryForm).then(res => {
        let result = res.data.data;
        // that.tableData = that.moveItemToFirst(result.records, this.currentNotifyId)
        that.tableData = result.records

        that.paginations.total = Number(result.total)
        that.paginations.current = Number(result.current)
        that.paginations.size = Number(result.size)
      })
    },
    handleCurrentChange(page) {
      // 切换页码
      this.paginations.current = page
      this.handlePage()
    },
    handleSizeChange(size) {
      // 切换size
      this.paginations.size = size
      this.size = size
      this.handlePage()
    }
  }
}
</script>
<style scoped lang="scss">
::v-deep .el-tooltip__popper {
  max-width: 200px;
}
.pagination-fixed {
  position: fixed;
  bottom: 0;
  right: 0;
  margin-bottom: -2rem;
  margin-right: 8px;
  background: #FAFAFD;
  padding: 1rem 0;
}
.custom-select {
    /deep/ .el-input__inner {
      border-radius: 20px;
      height: 1.5rem;
      line-height: 1.5rem;
    }
    /deep/ .el-input__suffix {
      height: 1.5rem;
      line-height: 1.5rem;
      font-size: 12px;
      display: flex;
      align-items: center;
    }
}
/* 取消行悬停效果 */
/deep/ .el-table--enable-row-hover {
    background-color: transparent !important;
}

/* 取消行过渡效果 */
/deep/ .el-table--enable-row-transition {
    transition: none !important;
}
/deep/ .el-table th.el-table__cell.is-leaf, /deep/ .el-table td.el-table__cell {
  border-bottom: none;
}
.table-container {
  margin-bottom: 1rem;
  /deep/ .el-table__body {
    border-spacing: 0 10px;
    border-radius: 20px;
    width: auto !important;
  }
  /deep/ .el-table__body-wrapper.is-scrolling-left{
    width: auto !important;
  }
  /deep/ .el-table__body-wrapper .el-table__empty-block {
    width: auto !important;
  }
}

::v-deep .el-table td:first-child {
  border-radius: 20px 0 0 20px;
  padding-left: 2rem;
}
::v-deep .el-table td:last-child {
  border-radius: 0 20px 20px 0;
}

::v-deep td.el-table__cell {
  color: rgba(0,0,0,0.8);
  background-color: transparent !important;
}
::v-deep .el-table .el-table__cell:first-child {
  font-weight: bold;
  padding-left: 2rem;
}
::v-deep .el-table__row:hover{
  background-color: #E5E7FC !important;
}
::v-deep .el-table__row {
  font-weight: 400;
  font-size: 14px;
  color: rgba(0,0,0,0.8);
}
.max-width-column .cell {
  max-width: 15rem; /* 设置最大宽度 */
  white-space: nowrap; /* 防止文本换行 */
  overflow: hidden; /* 隐藏超出部分 */
  text-overflow: ellipsis; /* 显示省略号 */
}

.data-empty {
  padding: 1rem;
  height: calc( 100vh - 8rem );
}
/deep/ .el-empty {

}
/deep/ .el-empty__bottom {
  margin-top: 10px;
}
/deep/ .el-table__empty-text {
  line-height: 0px !important;
}
.search-title {
  /deep/ .el-input__inner {
    height: 1.5rem;
    line-height: 1.5rem;
    font-size: 12px;
  }
  /deep/ .el-input__suffix {
    height: 1.5rem;
    line-height: 1.5rem;
    font-size: 12px;
    display: flex;
    align-items: center;
  }
}
/* CSS样式 */
.image-switcher {
  display: inline-block;
  width: 14px;
  height: 14px;
  background-size: cover;
  transition: background-image 0.3s; /* 平滑过渡效果 */
  &-sousuo-hui {
    background-image: url('../../assets/icon-sousuo.png'); /* 默认状态下的图片 */
  }
  &-sousuo {
    background-image: url('../../assets/icon-sousuo.png'); /* 默认状态下的图片 */
  }
  &-sousuo:hover {
    background-image: url('../../assets/icon-sousuo-1.png'); /* 默认状态下的图片 */
  }
  &-sousuo:active {
    background-image: url('../../assets/icon-sousuo.png'); /* 默认状态下的图片 */
  }

  &-edit {
    background-image: url('../../assets/icon-edit.png'); /* 默认状态下的图片 */
  }
  &-edit:hover {
    background-image: url('../../assets/icon-edit-1.png'); /* 默认状态下的图片 */
  }
  &-edit:active {
    background-image: url('../../assets/icon-edit.png'); /* 默认状态下的图片 */
  }

  &-chaishu {
    background-image: url('../../assets/icon-chaishu.png'); /* 默认状态下的图片 */
  }
  &-chaishu:hover {
    background-image: url('../../assets/icon-chaishu-1.png'); /* 默认状态下的图片 */
  }
  &-chaishu:active {
    background-image: url('../../assets/icon-chaishu.png'); /* 默认状态下的图片 */
  }

  &-delete {
    background-image: url('../../assets/icon-delete.png'); /* 默认状态下的图片 */
  }
  &-delete:hover {
    background-image: url('../../assets/icon-delete-1.png'); /* 默认状态下的图片 */
  }
  &-delete:active {
    background-image: url('../../assets/icon-delete.png'); /* 默认状态下的图片 */
  }
}
.single-line-content {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
}
</style>
